<template>
  <div>
    <div>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#"></a>
            <router-link :to="{name: 'account-emv-clearings', params: {id: accountId}}">
              {{ $t('emvClearings.account.pageSingle.backLinkLabel') }}
            </router-link>
          </li>
          <li class="breadcrumb-item active" aria-current="page"> {{ resourceId }}</li>
        </ol>
      </nav>
    </div>
    <div>

    </div>

    <div>
      <card>
        <template slot="header">
          <h4 class="card-title d-inline">{{ $t('emvClearings.account.pageSingle.title') }}</h4>
        </template>
        <template>
          <div v-loading="loading">
            <card v-if="entry">
              <emv-clearing-details :details="entry"/>
            </card>
          </div>
        </template>
      </card>
    </div>
  </div>
</template>

<script>
import EmvClearingDetails from 'src/components/EmvClearing/EmvClearingDetails'
import {mapActions, mapState} from "vuex";

export default {
  name: "AccountEmvClearing",
  components: {
    EmvClearingDetails,
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
    resourceId: {
      type: String,
      required: true
    },
  },
  methods: {
    ...mapActions(['LoadAccountEmvClearing']),
  },
  mounted() {
    // Loading user top-up data
    this.LoadAccountEmvClearing({accountID: this.accountId, resourceId: this.resourceId});
  },
  computed: {
    ...mapState({
      // darkTheme: state => state.app.darkMode,
      loading: state => state.account_emv_clearing.loading,
      entry: state => state.account_emv_clearing.data,
    }),
  },
}
</script>

